export default __webpack_public_path__ + "static/media/wallet.00ecbb37.svg";